<template>
  <div class="home">
    <KnowledgeBase :limit="5" />

    <h2>Questionnaire-Catalogues <router-link to="/catalogue/new" class="btn btn-primary">+</router-link></h2>
    <b-card v-for="catalogue in catalogues" :title=catalogue.name :sub-title=catalogue.subtitle>
        <p class="card-text">
            {{ catalogue.description }}
        </p>
        <router-link :to="{ path: 'audit', query: {catalogue: catalogue._id}}" class="btn btn-primary card-link">New Audit</router-link>
        <router-link :to="'/catalogue/' + catalogue._id + '/edit'" class="btn btn-secondary float-right">Edit</router-link>
    </b-card>
    <br />
    <h2>Audits</h2>
    <b-table :items="audits" :fields="fields">
      <template slot="status" slot-scope="data">
        <b-btn variant="primary" :to="'/audit/' + data.item.audit_id">Details</b-btn>
      </template>
    </b-table>
    <QuestionnaireGroups />
  </div>
</template>

<script>
// @ is an alias to /src
import QuestionnaireGroups from '@/components/QuestionnaireGroups.vue'
import KnowledgeBase from '@/views/KnowledgeBase.vue'

export default {
  name: 'home',
  components: {
    QuestionnaireGroups,
    KnowledgeBase
  },
  data: function () {
    return {
      audits: [],
       
      catalogues: [],
      fields: [
        {
          key: 'order_no',
          sortable: true
        },
        {
          key: 'date',
          sortable: true
        },
        {
          key: 'reason'
        },
        {
          key: 'supplier'
        },
        {
          key: 'status',
          label: 'Actions'
        },
      ]
    }
  },
  created () {
      this.fetchData()
  },
  watch: {
      '$route': 'fetchData'
  },
  methods: {
      fetchData() {
          this.error = null;
          this.loading = true;
          this.$http.get('v1/questionnairecatalogues').then(response => {
              this.catalogues = response.data.response;
              this.loading = false;
          });
          this.$http.get('v1/audits').then(response => {
            this.audits = response.data.response;
          })
      }
  }
}
</script>
